// extracted by mini-css-extract-plugin
export default {"panel":"H3ah","content":"xOyw","upseller":"PsnM","small":"r84a","upgrade-button":"NEGX","upgradeButton":"NEGX"};